import { render, staticRenderFns } from "./NvrComp.vue?vue&type=template&id=350ef434&scoped=true"
import script from "./NvrComp.vue?vue&type=script&lang=js"
export * from "./NvrComp.vue?vue&type=script&lang=js"
import style0 from "./NvrComp.vue?vue&type=style&index=0&id=350ef434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ef434",
  null
  
)

export default component.exports